(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["unparalleled-reactive"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('interactive-unprlld')) {
    class InteractiveUnprlld extends HTMLElement {
      connectedCallback() {
        this.canvas = this.querySelector('canvas');
        this.context = this.canvas.getContext('2d');
        this.coordinateX = this.querySelector('[data-coordinate-x]');
        this.coordinateY = this.querySelector('[data-coordinate-y]');
        this.pointer = { x: 0, y: 0 };
        this.target = { x: 0, y: 0 };
        this.particles = [];
        this.running = true;
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.handlePointer = this.handlePointer.bind(this);
        this.handleLeave = this.handleLeave.bind(this);
        this.resize = this.resize.bind(this);
        this.animate = this.animate.bind(this);
        this.resizeObserver = new ResizeObserver(this.resize);
        this.resizeObserver.observe(this);
        this.addEventListener('pointermove', this.handlePointer, { passive: true });
        this.addEventListener('pointerleave', this.handleLeave, { passive: true });
        document.addEventListener('visibilitychange', () => {
          this.running = !document.hidden;
          if (this.running) requestAnimationFrame(this.animate);
        });
        this.resize();
      }

      disconnectedCallback() {
        this.running = false;
        this.resizeObserver?.disconnect();
        this.removeEventListener('pointermove', this.handlePointer);
        this.removeEventListener('pointerleave', this.handleLeave);
      }

      createParticle(far = false) {
        return {
          x: (Math.random() - 0.5) * 2.3,
          y: (Math.random() - 0.5) * 2.3,
          z: far ? 1.65 : Math.random() * 1.55 + 0.1,
          size: Math.random() * 1.8 + 0.45,
          color: Math.random() > 0.72 ? '#ed1017' : Math.random() > 0.45 ? '#ffffff' : '#a9a9a9',
          drift: (Math.random() - 0.5) * 0.0007
        };
      }

      resize() {
        const bounds = this.getBoundingClientRect();
        const ratio = Math.min(window.devicePixelRatio || 1, 2);
        this.width = bounds.width;
        this.height = bounds.height;
        this.canvas.width = Math.round(this.width * ratio);
        this.canvas.height = Math.round(this.height * ratio);
        this.canvas.style.width = `${this.width}px`;
        this.canvas.style.height = `${this.height}px`;
        this.context.setTransform(ratio, 0, 0, ratio, 0, 0);
        const count = Math.max(90, Math.min(240, Math.round((this.width * this.height) / 5600)));
        this.particles = Array.from({ length: count }, () => this.createParticle());
        this.draw(0);
        if (!this.reducedMotion) requestAnimationFrame(this.animate);
      }

      handlePointer(event) {
        const bounds = this.getBoundingClientRect();
        this.target.x = ((event.clientX - bounds.left) / bounds.width - 0.5) * 2;
        this.target.y = ((event.clientY - bounds.top) / bounds.height - 0.5) * 2;
      }

      handleLeave() {
        this.target.x = 0;
        this.target.y = 0;
      }

      draw(time) {
        const context = this.context;
        context.clearRect(0, 0, this.width, this.height);
        const glowX = this.width * (0.5 + this.pointer.x * 0.16);
        const glowY = this.height * (0.48 + this.pointer.y * 0.12);
        const gradient = context.createRadialGradient(glowX, glowY, 0, glowX, glowY, Math.max(this.width, this.height) * 0.54);
        gradient.addColorStop(0, 'rgba(237,16,23,0.14)');
        gradient.addColorStop(0.38, 'rgba(120,120,120,0.035)');
        gradient.addColorStop(1, 'rgba(0,0,0,0)');
        context.fillStyle = gradient;
        context.fillRect(0, 0, this.width, this.height);

        const focal = Math.min(this.width, this.height) * 0.62;
        const velocity = 0.0032;
        for (const particle of this.particles) {
          if (!this.reducedMotion) {
            particle.z -= velocity;
            particle.x += particle.drift;
          }
          if (particle.z < 0.07) Object.assign(particle, this.createParticle(true));
          const x = this.width / 2 + (particle.x * focal) / particle.z + this.pointer.x * 30 * (1.7 - particle.z);
          const y = this.height / 2 + (particle.y * focal) / particle.z + this.pointer.y * 24 * (1.7 - particle.z);
          if (x < -40 || x > this.width + 40 || y < -40 || y > this.height + 40) {
            Object.assign(particle, this.createParticle(true));
            continue;
          }
          const scale = Math.min(5, particle.size * (1.7 / particle.z));
          context.globalAlpha = Math.min(0.9, 0.18 + (1.7 - particle.z) * 0.48);
          context.fillStyle = particle.color;
          context.fillRect(x, y, scale, scale);
        }
        context.globalAlpha = 1;
        this.style.setProperty('--pointer-x', this.pointer.x.toFixed(4));
        this.style.setProperty('--pointer-y', this.pointer.y.toFixed(4));
        this.style.setProperty('--spin', `${(time * 0.009) % 360}deg`);
        this.coordinateX.textContent = `X ${(this.pointer.x * 99).toFixed(2)}`;
        this.coordinateY.textContent = `Y ${(this.pointer.y * 99).toFixed(2)}`;
      }

      animate(time) {
        if (!this.running || this.reducedMotion) return;
        this.pointer.x += (this.target.x - this.pointer.x) * 0.055;
        this.pointer.y += (this.target.y - this.pointer.y) * 0.055;
        this.draw(time);
        requestAnimationFrame(this.animate);
      }
    }

    customElements.define('interactive-unprlld', InteractiveUnprlld);
  }

  } catch(e) { console.error(e); }
})();
})();
